(function ($) {
  Drupal.behaviors.aerinFragranceFinderFormatterV1 = {
    questionCount: 0,
    currentQuestionIndex: 0,
    currentQuestionAnswer: '',
    $html: $('html, body'),
    attach: function (context) {
      var self = this;
      var $modules = $('.js-aerin-fragrance-finder-formatter', context);

      $modules.each(function () {
        var $module = $(this);
        var $questions = $module.find('.js-aerin-ff-question-formatter');
        var $backArrow = $module.find('.js-aerin-fragrance-finder-formatter-arrow');
        var $contentHeader = $module.find('.js-aerin-fragrance-finder-formatter-content');
        var $results = $module.find('.js-aerin-fragrance-finder-result-formatter');
        var $result = $results.find('.js-aerin-fragrance-finder-result');
        var $starOver = $module.find('.js-aerin-fragrance-finder-result-formatter-cta');
        var $steps = $module.find('.js-aerin-ff-question-formatter-steps');
        var $stepsCounter = $steps.find('.js-aerin-ff-question-formatter-steps-counter');

        if ($module.hasClass('js-non-shoppable')) {
          $result.addClass('js-non-shoppable');
        }

        self.questionCount = $questions.length;
        self.stepsSetup($stepsCounter);

        $backArrow.once().on('click', function () {
          self.updateActiveQuestion(
            $module,
            $questions,
            self.currentQuestionIndex - 2,
            self.currentQuestionIndex - 1
          );
          self.backStep($results, $backArrow, $contentHeader, $stepsCounter);
        });

        $starOver.once().on('click', function () {
          $questions.addClass('aerin-ff-question-formatter__options--hide');
          $questions.eq(0).removeClass('aerin-ff-question-formatter__options--hide');
          $module.attr('data-answer', '');
          Drupal.behaviors.aerinFFQuestionFormatterV1['counter'] = 1;
          self.currentQuestionIndex = 1;
          self.backStep($results, $backArrow, $contentHeader, $stepsCounter);
          self.moveTop($module);
        });

        $stepsCounter.children().each(function (stepIndex) {
          $(this)
            .once()
            .on('click', function () {
              if (stepIndex + 1 < self.currentQuestionIndex) {
                self.updateActiveQuestion($module, $questions, stepIndex);
                self.backStep($results, $backArrow, $contentHeader, $stepsCounter);
              }
            });
        });

        $(document).on('af_question:question_change', function (e) {
          self.currentQuestionIndex = e.payload['counter'];
          self.currentQuestionAnswer = e.payload['answer'];
          self.updateSteps($stepsCounter);
          self.checkBackArrow($backArrow);
        });
      });
    },
    moveTop: function ($module) {
      var self = this;

      self.$html.animate(
        {
          scrollTop: $module.offset().top - 100
        },
        500
      );
    },
    backStep: function ($results, $backArrow, $contentHeader, $stepsCounter) {
      var self = this;

      $results.removeClass('aerin-fragrance-finder-result-formatter--show');
      $results
        .find('.js-aerin-fragrance-finder-result')
        .removeClass('aerin-fragrance-finder-result--show');
      self.checkBackArrow($backArrow);
      $contentHeader.removeClass('inactive');
      self.updateSteps($stepsCounter);
    },
    updateAnswer: function ($module, nextIndex) {
      var selectedAnswers = $module.attr('data-answer').split(',');
      var newAnswers;

      newAnswers = selectedAnswers.slice(0, nextIndex);
      $module.attr('data-answer', newAnswers.join());
    },
    updateActiveQuestion: function ($module, $questions, nextIndex, currentIndex) {
      var self = this;

      $questions.addClass('aerin-ff-question-formatter__options--hide');
      $questions.eq(nextIndex).removeClass('aerin-ff-question-formatter__options--hide');
      self.updateAnswer($module, nextIndex);
      currentIndex
        ? (self.currentQuestionIndex = currentIndex)
        : (self.currentQuestionIndex = nextIndex + 1);
      Drupal.behaviors.aerinFFQuestionFormatterV1['counter'] = self.currentQuestionIndex;
    },
    checkBackArrow: function ($backArrow) {
      var self = this;

      if (self.currentQuestionIndex <= 1) {
        $backArrow.removeClass('aerin-fragrance-finder-formatter__arrow--show');
      } else if (self.currentQuestionIndex > 1) {
        $backArrow.addClass('aerin-fragrance-finder-formatter__arrow--show');
      }
    },
    updateSteps: function ($stepsCounter) {
      var self = this;
      var $steps = $stepsCounter.children();

      $steps.removeClass('aerin-ff-question-formatter__steps-counter--active');
      $steps
        .eq(self.currentQuestionIndex - 1)
        .addClass('aerin-ff-question-formatter__steps-counter--active');
      $steps.removeClass('cursor-active');
      $steps.each(function (index) {
        if (index < self.currentQuestionIndex - 1) {
          $(this).addClass('cursor-active');
        }
      });
    },
    stepsSetup: function ($stepsCounter) {
      var self = this;
      var counterHtml = '';
      var i;

      for (i = 0; i < self.questionCount; i++) {
        counterHtml +=
          '<span class="aerin-ff-question-formatter__steps-counter--' + i + '"> </span>';
      }
      $stepsCounter.html(counterHtml);
      $stepsCounter
        .find('.aerin-ff-question-formatter__steps-counter--0')
        .addClass('aerin-ff-question-formatter__steps-counter--active');
    }
  };
})(jQuery);
